function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { deepExtract } from 'helpers/deep';
import AVAILABILITY_REASONS, { PLAN_DOES_NOT_ALLOW_RESERVATIONS } from 'constants/availability-reasons';
import { AVAILABLE, RESERVED } from 'constants/availability-statuses';

var SchedulesDeriver =
/*#__PURE__*/
function () {
  function SchedulesDeriver() {
    _classCallCheck(this, SchedulesDeriver);
  }

  _createClass(SchedulesDeriver, null, [{
    key: "availabilityData",
    value: function availabilityData(schedule) {
      var availability = schedule.availability,
          _schedule$override_av = schedule.override_availabilities,
          overrideAvailabilities = _schedule$override_av === void 0 ? [] : _schedule$override_av;
      var isTopUp = this.isTopUp(schedule);
      var topUpReason = deepExtract('availability.top_up.purchase.reason', schedule, null);
      var credits = deepExtract('availability.credits', schedule, null);
      var creditsReasons = deepExtract('availability.credits_reasons', schedule, []);
      var availableToReserve = availability.status === AVAILABLE || isTopUp || overrideAvailabilities.some(function (override) {
        return override.purchase && override.purchase.type === 'purchase-plus';
      });
      var creditsType = deepExtract('availability.credits_type', schedule, null);
      return {
        availableToReserve: availableToReserve,
        reasonCannotReserve: this.getReason(schedule) || null,
        reasonCode: availability.reason,
        isReserved: this.isReserved(schedule),
        label: availability.label || null,
        creditsReason: isTopUp && topUpReason || creditsReasons.length && creditsReasons[0],
        availableToPurchase: this.isAvailableToPurchase(schedule),
        credits: credits,
        isTopUp: isTopUp,
        creditsType: creditsType
      };
    }
  }, {
    key: "getReason",
    value: function getReason(schedule) {
      var availability = schedule.availability;

      if (this.isAvailableToPurchase(schedule) && availability.reason === PLAN_DOES_NOT_ALLOW_RESERVATIONS) {
        return;
      }

      return AVAILABILITY_REASONS[availability.reason];
    }
  }, {
    key: "groupByDay",
    value: function groupByDay(schedules) {
      return schedules.reduce(function (memo, schedule) {
        var startDate = new Date(schedule.starttime * 1e3).toISOString().substring(0, 10);

        if (!memo[startDate]) {
          memo[startDate] = [];
        }

        memo[startDate].push(schedule);
        return memo;
      }, {});
    }
  }, {
    key: "isAvailableToPurchase",
    value: function isAvailableToPurchase(schedule) {
      var availability = schedule.availability,
          _schedule$override_av2 = schedule.override_availabilities,
          overrideAvailabilities = _schedule$override_av2 === void 0 ? [] : _schedule$override_av2;
      return !!availability.purchase || overrideAvailabilities.length > 0;
    }
  }, {
    key: "isReserved",
    value: function isReserved(schedule) {
      return deepExtract('availability.status', schedule) === RESERVED;
    }
  }, {
    key: "isTopUp",
    value: function isTopUp(schedule) {
      var topUp = deepExtract('availability.top_up', schedule, null);
      return !!topUp;
    }
  }]);

  return SchedulesDeriver;
}();

export { SchedulesDeriver as default };